import React, { useState } from 'react';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import {
  FDStack,
  FDHorizontalTabs,
  FDTabPanel, FDPrimaryActionButton,
} from '@facet-wealth/design';
import { RoadmapExplorerGoalsAccordion } from 'Components/UI/roadmapExplorer/goalsAccordion';
import MetaControl from 'Components/UI/Meta/MetaControl';
import { dataAttrs } from 'Helpers/Testing';
import { GuidedHouseholdReviewZoneDescriptions } from 'Components/UI/guidedHouseholdReview/zoneDescriptions';
import { WizardBackButtonRel } from 'Packages/FacetCore/Experimental/RelationshipComponents/WizardBackButtonRel';
import { metaOverrideSet } from './metaOverrideSet';

export const GuidedHouseholdReviewGoalsWithThresholdsLayout = () => {
  const { resource, saving, onSubmit } = useMetaLayoutContext();
  const goalsByTimeframe = resource.attr('goalsByTimeframe').resources().list();
  const [selectedGoalCategoryID, setSelectedGoalCategoryID] = useState(goalsByTimeframe[0].id());

  const onContinue = () => {
    const newIndex = 1 + goalsByTimeframe.findIndex(goals => goals.id() === selectedGoalCategoryID);
    if (newIndex === goalsByTimeframe.length) {
      onSubmit();
      return;
    }
    setSelectedGoalCategoryID(goalsByTimeframe[newIndex].id());
  };

  return (
    <FDStack direction={'column'} justifyContent="flex-start" alignItems="center" flex={1} spacing={3} paddingY={4}>
      <FDStack direction={'column'} alignItems="center" spacing={1}>
        <FDHorizontalTabs
          options={goalsByTimeframe.map(goalCategory => ({ label: goalCategory.attr('name'), value: goalCategory.id() }))}
          value={selectedGoalCategoryID}
          onChange={(_, value) => setSelectedGoalCategoryID(value)}
        />
        {goalsByTimeframe.map(goalCategory => (
          <FDTabPanel id={goalCategory.id()} value={selectedGoalCategoryID}>
            <FDStack direction="column" alignItems="center" spacing={3}>
              <MetaControl resource={goalCategory} attrName="description" metaOverrideSet={metaOverrideSet} />
              <RoadmapExplorerGoalsAccordion goals={goalCategory.attr('goals').resources().list()} />
            </FDStack>
          </FDTabPanel>
        ))}
        <GuidedHouseholdReviewZoneDescriptions resource={resource} />
      </FDStack>
      <FDStack direction="row" justifyContent="center" spacing={2}>
        <WizardBackButtonRel size="lg" resource={resource} />
        <FDPrimaryActionButton
          {...dataAttrs('submit-btn')}
          loading={saving}
          onClick={onContinue}
          label={resource.attr('primaryActionLabel') || 'Submit'}
          size="lg"
          icon="arrowRight"
          iconPosition="end"
        />
      </FDStack>
    </FDStack>
  );
};
